import React from "react";
import TopMenuBar from "../TopMenuBar";
import Container from "@mui/material/Container";
import useGetVideos from "../../services/useGetVideos";
import { VideoModel } from "../../Models/VideoModel";
import { WistiaPlayer } from "@wistia/wistia-player-react";
import Grid from "@mui/material/Grid2";
import { Helmet } from "react-helmet";

const ChangeCallsPage: React.FC = () => {
  function getUrl(): string {
    if (typeof window == "undefined") return "";
    return window.location.href;
  }

  let metaTitle = "ChangePilot Change Calls";
  let metaDescription = `A live event, hosted by our subject matter experts, running through every Microsoft 365 Message Center item each month. Recording and per-item time stamps also available on demand.`;
  const fallBackLogo =
    window.location.protocol +
    "//" +
    window.location.hostname +
    "/ChangePilotFaviconMint500px.png";
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: metaTitle,
    alternateName: "ChangePilot Change Calls",
    url: getUrl(),
    image: fallBackLogo,
  };

  const data = useGetVideos();
  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        {metaDescription && (
          <meta name="description" content={metaDescription} />
        )}
        {metaTitle && <meta property="og:title" content={metaTitle} />}
        {metaDescription && (
          <meta property="og:description" content={metaDescription} />
        )}
        <meta property="og:type" content="website"></meta>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        {getUrl() && <meta property="og:url" content={getUrl()} />}
        <meta property="og:image" content={fallBackLogo} />
        <link rel="canonical" href={getUrl()} />
      </Helmet>

      <TopMenuBar />

      <Container maxWidth="xl" sx={{ mt: 4 }}>
        <h1>ChangePilot Change Calls</h1>
        <Grid
          container
          spacing={{ xs: 1, md: 2 }}
          columns={{ xs: 2, sm: 4, md: 6 }}
        >
          {data.data?.map((video: VideoModel) => {
            return (
              <Grid key={video.id} size={{ xs: 2, sm: 3, md: 3 }}>
                <h2>{video.title}</h2>
                <WistiaPlayer mediaId={video.embedCode} autoplay={false} />
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </>
  );
};

export default ChangeCallsPage;
